<div class="order-reference-editor" *ngIf="condition" [formGroup]="detailsFormGroup">
    <sc-flex [vertical]="true" [stretchContent]="true">
        <sc-checkbox-field formControlName="train"
            [label]="'' | translate:['tmc-yard.entity.transport.transport-scope.TRAIN',translationService.language]"></sc-checkbox-field>
        <sc-checkbox-field formControlName="trailer"
            [label]="'' | translate:['tmc-yard.entity.transport.transport-scope.TRAILER',translationService.language]"></sc-checkbox-field>
        <sc-checkbox-field formControlName="swapTrailer"
            [label]="'' | translate:['tmc-yard.entity.transport.transport-scope.SWAP_TRAILER',translationService.language]"></sc-checkbox-field>

    </sc-flex>

</div>
